import React from 'react'
import possibilityImage from '../../assets/possibility.png';
import './possibility.css';

const Possibility = () => {
  return (
    <div className='webpage__possibility section__padding ' id='possibility'>
      <div className='webpage__possibility-image'>
        <img src={possibilityImage} alt="possibility"/>
      </div>
      <div className='webpage__possibility-content'>
        <h4>request early access to get started</h4>
        <h1 className='gradient__text'>The possibilites are beyond our imaginatiuons</h1>
        <p>thebeh sjhbdh dokjodia kshofhsf hoeihf sdijoisd sdiijpsid sdijpojsd ;skjspidjdpf kjspdiojof;ojspdojf s;ojopovjs skjpfihspd sldjbovvuhsb</p>
        <h4>request early access to get started</h4>
      </div>
    </div>
  )
}

export default Possibility